/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface SitePermissionSessionStartView { 
    sessionId?: string;
    loginUrl?: string;
    status?: SitePermissionSessionStartView.StatusEnum;
}
export namespace SitePermissionSessionStartView {
    export type StatusEnum = 'AWAITING_LOGIN' | 'AWAITING_SELECTION' | 'AWAITING_APPLY_LOGIN' | 'COMPLETED' | 'COMPLETED_WITH_ERRORS' | 'FAILED';
    export const StatusEnum = {
        AWAITINGLOGIN: 'AWAITING_LOGIN' as StatusEnum,
        AWAITINGSELECTION: 'AWAITING_SELECTION' as StatusEnum,
        AWAITINGAPPLYLOGIN: 'AWAITING_APPLY_LOGIN' as StatusEnum,
        COMPLETED: 'COMPLETED' as StatusEnum,
        COMPLETEDWITHERRORS: 'COMPLETED_WITH_ERRORS' as StatusEnum,
        FAILED: 'FAILED' as StatusEnum
    };
}